import PageHeader from '../layout/PageHeader'
import ScienceIcon from '@mui/icons-material/Science'
import DataTable from '../dataTable/DataTable'
import { useSelector } from 'react-redux'
import { Card, CardContent, CardHeader, Button } from '@mui/material'
import PageContainer from '../layout/PageContainer'
import StoreKeyProvider from '../../providers/StoreKeyProvider'
import WithFilters from '../../hocs/WithFilters'
import DataInputs from '../dataTable/DataInputs'
import axios from 'axios'
import DownloadIcon from '@mui/icons-material/Download'
import { useEffect, useState } from 'react'
import filtersBuilder from '../../../lib/filtersBuilder'
import downloader from '../../../lib/downloader'
import moment from 'moment'
import eventBus from '../../../lib/eventBus'

const parseAllExaminations = (examinations) => {
  let result = []
  const typesKeys = Object.keys(examinations)
  for (let i = 0; i < typesKeys.length; i++) {
    result = [...result, ...examinations[typesKeys[i]]]
  }
  return result
}

const Examinations = () => {
  const filters = useSelector(
    (state) => state.filters.filters['ExaminationsKey'].inputs
  )

  const user = useSelector((state) => state.user.user)

  const [examinations, setExaminations] = useState()
  const [allExaminations, setAllExaminations] = useState()
  const [examinationsTypes, setExaminationsTypes] = useState()
  const [chosenExaminationsType, setChosenExaminationsType] = useState()
  const [medicalFacilities, setMedicalFacilities] = useState([])
  const [medical_care, setMecicalCare] = useState([])

  useEffect(() => {
    axios.post('lookups/examinations', null).then((res) => {
      setExaminations(res.data)
      setAllExaminations(parseAllExaminations(res.data))
    })
    axios.post('lookups/examination_types', null).then((res) => {
      setExaminationsTypes(res.data)
    }),
      axios.post('/lookups/medical_facilities', null).then((res) => {
        setMedicalFacilities(res.data)
      }),
      axios.post('/lookups/medical_care', null).then((res) => {
        setMecicalCare(res.data)
      })
  }, [])

  useEffect(() => {
    eventBus.on('newFilterValues', async (data) => {
      await setChosenExaminationsType(data.type_id)
    })

    return eventBus.remove('newFilterValues')
  }, [])

  useEffect(() => {
    eventBus.dispatch('forceFilterValue', {
      key: 'examination_id',
      value: null,
      filter: 'ExaminationsKey',
    })
  }, [chosenExaminationsType])

  // DOWNLOADER
  const downloadRaport = () => {
    axios
      .post(
        'reports/audit',
        {
          filters: filtersBuilder(filters),
        },
        {
          responseType: 'blob',
          headers: {
            Accept: '',
          },
        }
      )
      .then((res) => {
        downloader({
          type: 'application/xlsx',
          data: res.data,
          name: `Raport ${moment().format('L')}.xlsx`,
        })
      })
      .catch((err) => {
        console.log(err)
      })
  }

  return (
    <>
      <PageHeader
        icon={<ScienceIcon fontSize="large" />}
        title="Wyniki badań"
        subtitle="Tutaj znajdziesz listę wyników badań"
      />
      <PageContainer>
        <StoreKeyProvider storeKey="ExaminationsKey">
          <WithFilters
            config={{
              page: 1,
              paginate: 10,
              orderType: 'desc',
              order: 'created_at',
              inputs: {
                type_id: {
                  value: '',
                  relation: 'LIKE',
                },
                examination_id: {
                  value: null,
                  relation: 'WHERE',
                },
                min_created_at: {
                  value: null,
                  relation: 'MIN',
                },
                max_created_at: {
                  value: null,
                  relation: 'MAX',
                },
                pesel: {
                  value: '',
                  relation: 'LIKE',
                },
                patient_name: {
                  value: '',
                  relation: 'LIKE',
                },
                user_name: user.role_id == 1 && {
                  value: '',
                  relation: 'LIKE',
                },
                doctor_name: user.role_id == 1 && {
                  value: '',
                  relation: 'LIKE',
                },
                medical_facility_id: {
                  value: '',
                  relation: 'WHERE',
                },
                medical_care_id: {
                  value: '',
                  relation: 'WHERE',
                },
              },
            }}
            endpoint="/examinations"
          >
            <Card elevation={2} square>
              <CardHeader
                title="Lista wyników badań"
                action={
                  user.role_id == 1 &&
                  user.permissions.includes('generate Audit Report') && (
                    <Button
                      className="sm_header_custom_w:hidden"
                      startIcon={<DownloadIcon />}
                      variant="contained"
                      color="primary"
                      onClick={downloadRaport}
                    >
                      wygeneruj raport
                    </Button>
                  )
                }
              ></CardHeader>
              <CardContent>
                {examinations && examinationsTypes && medical_care && (
                  <DataInputs
                    inputs={
                      user.role_id == 1
                        ? [
                            {
                              id: 'type_id',
                              label: 'Typ',
                              placeholder: '',
                              type: 'select',
                              options: examinationsTypes,
                            },
                            {
                              id: 'examination_id',
                              label: 'Badanie',
                              placeholder: '',
                              type: 'select',
                              options: chosenExaminationsType
                                ? examinations[chosenExaminationsType]
                                : allExaminations,
                            },
                            {
                              id: 'created_at',
                              label: 'Data wykonania',
                              placeholder: '',
                              type: 'date-between',
                            },
                            {
                              id: 'pesel',
                              label: 'PESEL',
                              placeholder: '',
                              type: 'text',
                            },
                            {
                              id: 'medical_facility_id',
                              label: 'Placówka medyczna',
                              placeholder: '',
                              size: 2,
                              type: 'select',
                              options: medicalFacilities,
                              config: {
                                key: 'id',
                                label: 'name+nip+address',
                                separator: ' - ',
                              },
                            },
                            {
                              id: 'medical_care_id',
                              label: 'Opieka medyczna',
                              placeholder: '',
                              type: 'select',
                              options: medical_care,
                            },
                            {
                              id: 'patient_name',
                              label: 'Pacjent',
                              placeholder: '',
                              type: 'text',
                            },
                            {
                              id: 'user_name',
                              label: 'Administrator',
                              placeholder: '',
                              type: 'text',
                            },
                          ]
                        : user.role_id == 2
                        ? [
                            {
                              id: 'created_at',
                              label: 'Data wykonania',
                              placeholder: '',
                              type: 'date-between',
                            },
                            {
                              id: 'pesel',
                              label: 'PESEL',
                              placeholder: '',
                              type: 'text',
                            },
                            {
                              id: 'patient_name',
                              label: 'Imię/Nazwisko',
                              placeholder: '',
                              type: 'text',
                            },
                          ]
                        : [
                            {
                              id: 'created_at',
                              label: 'Data wykonania',
                              placeholder: '',
                              type: 'date-between',
                            },
                            {
                              id: 'patient_name',
                              label: 'Pacjent',
                              placeholder: '',
                              type: 'text',
                            },
                          ]
                    }
                  />
                )}
                <DataTable
                  breakpoint={1484}
                  actions="ExaminationsTableActions"
                  labels={
                    user.role_id == 1
                      ? [
                          'Badanie',
                          'Nr. zęba',
                          'Data wykonania',
                          'Pesel',
                          'Opieka medyczna',
                          'Placówka medyczna',
                          'Imię/Nazwisko',
                          'Administrator',
                        ]
                      : user.role_id == 2
                      ? [
                          'Badanie',
                          'Nr. zęba',
                          'Data wykonania',
                          'Pesel',
                          'Imię/Nazwisko',
                        ]
                      : [
                          'Badanie',
                          'Nr. zęba',
                          'Data wykonania',
                          'Lekarz',
                          'Pacjent',
                        ]
                  }
                  keys={
                    user.role_id == 1
                      ? [
                          'examination_name',
                          'tooth1',
                          'created_at',
                          'pesel',
                          'medical_care_name',
                          'facility_name',
                          'patient_name',
                          'user_name',
                        ]
                      : user.role_id == 2
                      ? [
                          'examination_name',
                          'tooth1',
                          'created_at',
                          'pesel',
                          'patient_name',
                        ]
                      : [
                          'examination_name',
                          'tooth1',
                          'created_at',
                          'doctor_name',
                          'patient_name',
                        ]
                  }
                />
              </CardContent>
            </Card>
          </WithFilters>
        </StoreKeyProvider>
      </PageContainer>
    </>
  )
}

export default Examinations
